module.exports = __webpack_public_path__ + "media/fonts/garamond/AGaramondPro-Semibold-ab60e034ab94b1ae8ddeb88ad0d16496.woff2";